import {dataState} from './stores/data.store';

export const StoresArchive = {
  dataState,
};
